import { render, staticRenderFns } from "./InheritanceTax.vue?vue&type=template&id=c919f8cc"
import script from "./InheritanceTax.vue?vue&type=script&lang=js"
export * from "./InheritanceTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports